// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/PPMondwest-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/PPNeueBit-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/N27-Regular.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: PP Mondwest;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }
  
  @font-face {
    font-family: PP NeueBit;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }
  
  @font-face {
    font-family: N27;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  }
  
  .body {
    background: #eff0eb;
  }
  
  .header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .frame {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-around;
    align-items: baseline;
    margin-top: 12.5vh;
  }
  
  .left {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: -moz-fit-content;
    height: fit-content;
    align-items: flex-start;
    width: 50%;
  }
  
  .top {
  
    margin-left: 7.5vw;
    width: 35.7vw;
  }
  
  .socials {
    position: relative;
    left: 10vw;
    width: 160px;
    font-family: N27;
    font-size: 10px;
    font-style: italic;
    font-weight: 400;
    line-height: 14px;
    letter-spacing: 0em;
    text-align: left;
    margin-top: 55px;
  }
  
  
  
  .socials h2 {
    font-family: N27;
    font-size: 10px;
    font-style: italic;
    font-weight: 400;
    line-height: 14px;
    /* letter-spacing: 0em; */
    text-align: left;
    padding: 0px;
    margin: 0px;
    margin-top: 12px;
    margin-left: 32px;
  }
  
  .links {
    display: flex;
    margin-left: 17px;
    margin-top: 10px;
  }
  
  .links p {
    font-size: 1vw;
    text-align: center;
    margin: 0;
    margin-left: 5px;
    font-size: 14px;
  }
  
  .links a {
    display: flex;
    
    text-decoration: none;
    color: black;
    font-family: "PP NeueBit";
    font-style: normal;
    font-size: 16px;
    margin-left: 15px;
    align-items: center;
  }
  
  h1 {
    margin: 0;
  }
  
  .top-f {
    display: flex;
    justify-content: space-between;
    font-family: "N27";
    font-style: italic;
    font-weight: 400 !important;
    font-size: 14px !important;
  
    padding: 0px 0.65%;
  }
  
  /* .bng {
    text-align: right;
  } */
  
  .hack {
    display: block;
    font-family: "PP NeueBit";
    font-style: normal;
    font-weight: 700;
    font-size: 9vw;
    margin: 0px;
    /* transform: translate(0, -25px); */
  
  }
  
  .year {
    font-family: "PP Mondwest";
    font-style: normal;
    font-weight: 400;
    font-size: 250px;
    /* line-height: 369px; */
    margin: 0px;
    text-align: left;
  }
  
  .desc {
    left: 80px;
    font-family: "N27";
    font-style: italic;
    font-weight: 400;
    line-height: 22px;
    margin: 0;
    text-align: left;
    font-size: 0.99vw;
    transform: translate(0, -25px);
    padding: 0% 0.65%;
    margin-top: 25px;
  }
  
  .right {
    padding: 0;
    margin: 0;
    width: 50%;
  }
  
  .regtext{
    font-family: "N27";
    font-style: italic;
    font-weight: 400;
    font-size: 10px;
  }
  
  .sq {
    width: 8px;
    height: 8px;
    background: #151515;
    position: absolute;
  }
  
  .sr {
    right: 0px;
    margin-right: 7.75vw;
  }
  
  .sl {
    left: 0px;
    margin-left: 7.75vw;
  }
  .sq3 {
    width: 3px;
    height: 3px;
    background: #151515;
    position: absolute;
  }
  
  .linethin{
    width: 94px;
    height: 1px;
    background: #151515;
    transform: rotate(-90deg);
  
  }
  
  .linedot{
    display: flex;
    position: absolute;
    align-items: center;
    display: flex;
    position: absolute;
    align-items: center;
    flex-direction: column;
    align-items: center;
    align-content: center;
    justify-content: center;
    justify-items: center;
    width: 0px;
  
  }
  
  @media only screen and (max-width: 600px) {
    .main {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .frame {
      display: flex;
      flex-direction: column;
      width: 100%;
      justify-content: space-around;
      align-items: center;
      margin: 0;
      margin-top: 5vh;
    }
  
    .top-f {
      margin-bottom: 10px;
    }
  
    .form-body {
      width: 100%;
      margin-left: 0px;
    }
  
    .hack {
     
      font-family: "PP NeueBit";
      font-style: normal;
      font-weight: 400;
      font-size: 23vw;
      margin-top: 2.5%;
      transform: unset;
      /* width: 100%;
      margin: 0px;
      margin-bottom: 2vh; */
    }
  
    .left {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
    }
  
    .desc {
      font-size: 3vw;
      width: 90vw;
      position: relative;
      left: 0;
      top: 0;
      padding: 0% 0.65%;
      /* line-height: 15px; */
      text-align: left;
      margin-left: 0;
      margin-top: 6%;
    }
  
    .top {
      margin: 0;
      width: auto;
      min-height: 140px;
      height: 19vh;
    }
  
    .right {
      padding: 0;
      margin: 0;
      width: 90vw;
    }
  
    .socials{
      margin: auto;
      width: 105px !important;
      margin-top: 15px;
      left: 0px !important;
      font-size: 7.5px;
    }
    .links {
      display: flex;
      justify-content: center;
    }
  
    .links p {
      /* font-size: 15px;
      text-align: center;
      margin: 0; */
    }
  
    .links a {
      /* display: flex;
      margin: 15px;
      margin-left: 30px;
      text-decoration: none;
      color: black; */
      align-items: self-end;
    }
  
    .icon {
      font-size: 15px;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/Fom/components/ContactPage/ContactPage.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,4CAAqD;EACvD;;EAEA;IACE,uBAAuB;IACvB,4CAAiD;EACnD;;EAEA;IACE,gBAAgB;IAChB,4CAA8C;EAChD;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,6BAA6B;IAC7B,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,wBAAmB;IAAnB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;EACZ;;EAEA;;IAEE,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;EAClB;;;;EAIA;IACE,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,aAAa;;IAEb,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;IAClB,2BAA2B;IAC3B,0BAA0B;;IAE1B,kBAAkB;EACpB;;EAEA;;KAEG;;EAEH;IACE,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,oCAAoC;;EAEtC;;EAEA;IACE,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,wBAAwB;IACxB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,8BAA8B;IAC9B,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,oBAAoB;EACtB;;EAEA;IACE,SAAS;IACT,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,yBAAyB;;EAE3B;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,qBAAqB;IACrB,uBAAuB;IACvB,qBAAqB;IACrB,UAAU;;EAEZ;;EAEA;IACE;MACE,aAAa;MACb,sBAAsB;MACtB,mBAAmB;IACrB;IACA;MACE,aAAa;MACb,sBAAsB;MACtB,WAAW;MACX,6BAA6B;MAC7B,mBAAmB;MACnB,SAAS;MACT,eAAe;IACjB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,WAAW;MACX,gBAAgB;IAClB;;IAEA;;MAEE,yBAAyB;MACzB,kBAAkB;MAClB,gBAAgB;MAChB,eAAe;MACf,gBAAgB;MAChB,gBAAgB;MAChB;;2BAEqB;IACvB;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,mBAAmB;MACnB,WAAW;IACb;;IAEA;MACE,cAAc;MACd,WAAW;MACX,kBAAkB;MAClB,OAAO;MACP,MAAM;MACN,iBAAiB;MACjB,uBAAuB;MACvB,gBAAgB;MAChB,cAAc;MACd,cAAc;IAChB;;IAEA;MACE,SAAS;MACT,WAAW;MACX,iBAAiB;MACjB,YAAY;IACd;;IAEA;MACE,UAAU;MACV,SAAS;MACT,WAAW;IACb;;IAEA;MACE,YAAY;MACZ,uBAAuB;MACvB,gBAAgB;MAChB,oBAAoB;MACpB,gBAAgB;IAClB;IACA;MACE,aAAa;MACb,uBAAuB;IACzB;;IAEA;MACE;;kBAEY;IACd;;IAEA;MACE;;;;qBAIe;MACf,qBAAqB;IACvB;;IAEA;MACE,eAAe;IACjB;EACF","sourcesContent":["@font-face {\n    font-family: PP Mondwest;\n    src: url(\"../../assets/fonts/PPMondwest-Regular.otf\");\n  }\n  \n  @font-face {\n    font-family: PP NeueBit;\n    src: url(\"../../assets/fonts/PPNeueBit-Bold.otf\");\n  }\n  \n  @font-face {\n    font-family: N27;\n    src: url(\"../../assets/fonts/N27-Regular.otf\");\n  }\n  \n  .body {\n    background: #eff0eb;\n  }\n  \n  .header {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .frame {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    justify-content: space-around;\n    align-items: baseline;\n    margin-top: 12.5vh;\n  }\n  \n  .left {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    height: fit-content;\n    align-items: flex-start;\n    width: 50%;\n  }\n  \n  .top {\n  \n    margin-left: 7.5vw;\n    width: 35.7vw;\n  }\n  \n  .socials {\n    position: relative;\n    left: 10vw;\n    width: 160px;\n    font-family: N27;\n    font-size: 10px;\n    font-style: italic;\n    font-weight: 400;\n    line-height: 14px;\n    letter-spacing: 0em;\n    text-align: left;\n    margin-top: 55px;\n  }\n  \n  \n  \n  .socials h2 {\n    font-family: N27;\n    font-size: 10px;\n    font-style: italic;\n    font-weight: 400;\n    line-height: 14px;\n    /* letter-spacing: 0em; */\n    text-align: left;\n    padding: 0px;\n    margin: 0px;\n    margin-top: 12px;\n    margin-left: 32px;\n  }\n  \n  .links {\n    display: flex;\n    margin-left: 17px;\n    margin-top: 10px;\n  }\n  \n  .links p {\n    font-size: 1vw;\n    text-align: center;\n    margin: 0;\n    margin-left: 5px;\n    font-size: 14px;\n  }\n  \n  .links a {\n    display: flex;\n    \n    text-decoration: none;\n    color: black;\n    font-family: \"PP NeueBit\";\n    font-style: normal;\n    font-size: 16px;\n    margin-left: 15px;\n    align-items: center;\n  }\n  \n  h1 {\n    margin: 0;\n  }\n  \n  .top-f {\n    display: flex;\n    justify-content: space-between;\n    font-family: \"N27\";\n    font-style: italic;\n    font-weight: 400 !important;\n    font-size: 14px !important;\n  \n    padding: 0px 0.65%;\n  }\n  \n  /* .bng {\n    text-align: right;\n  } */\n  \n  .hack {\n    display: block;\n    font-family: \"PP NeueBit\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 9vw;\n    margin: 0px;\n    /* transform: translate(0, -25px); */\n  \n  }\n  \n  .year {\n    font-family: \"PP Mondwest\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 250px;\n    /* line-height: 369px; */\n    margin: 0px;\n    text-align: left;\n  }\n  \n  .desc {\n    left: 80px;\n    font-family: \"N27\";\n    font-style: italic;\n    font-weight: 400;\n    line-height: 22px;\n    margin: 0;\n    text-align: left;\n    font-size: 0.99vw;\n    transform: translate(0, -25px);\n    padding: 0% 0.65%;\n    margin-top: 25px;\n  }\n  \n  .right {\n    padding: 0;\n    margin: 0;\n    width: 50%;\n  }\n  \n  .regtext{\n    font-family: \"N27\";\n    font-style: italic;\n    font-weight: 400;\n    font-size: 10px;\n  }\n  \n  .sq {\n    width: 8px;\n    height: 8px;\n    background: #151515;\n    position: absolute;\n  }\n  \n  .sr {\n    right: 0px;\n    margin-right: 7.75vw;\n  }\n  \n  .sl {\n    left: 0px;\n    margin-left: 7.75vw;\n  }\n  .sq3 {\n    width: 3px;\n    height: 3px;\n    background: #151515;\n    position: absolute;\n  }\n  \n  .linethin{\n    width: 94px;\n    height: 1px;\n    background: #151515;\n    transform: rotate(-90deg);\n  \n  }\n  \n  .linedot{\n    display: flex;\n    position: absolute;\n    align-items: center;\n    display: flex;\n    position: absolute;\n    align-items: center;\n    flex-direction: column;\n    align-items: center;\n    align-content: center;\n    justify-content: center;\n    justify-items: center;\n    width: 0px;\n  \n  }\n  \n  @media only screen and (max-width: 600px) {\n    .main {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n    }\n    .frame {\n      display: flex;\n      flex-direction: column;\n      width: 100%;\n      justify-content: space-around;\n      align-items: center;\n      margin: 0;\n      margin-top: 5vh;\n    }\n  \n    .top-f {\n      margin-bottom: 10px;\n    }\n  \n    .form-body {\n      width: 100%;\n      margin-left: 0px;\n    }\n  \n    .hack {\n     \n      font-family: \"PP NeueBit\";\n      font-style: normal;\n      font-weight: 400;\n      font-size: 23vw;\n      margin-top: 2.5%;\n      transform: unset;\n      /* width: 100%;\n      margin: 0px;\n      margin-bottom: 2vh; */\n    }\n  \n    .left {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      width: 100%;\n    }\n  \n    .desc {\n      font-size: 3vw;\n      width: 90vw;\n      position: relative;\n      left: 0;\n      top: 0;\n      padding: 0% 0.65%;\n      /* line-height: 15px; */\n      text-align: left;\n      margin-left: 0;\n      margin-top: 6%;\n    }\n  \n    .top {\n      margin: 0;\n      width: auto;\n      min-height: 140px;\n      height: 19vh;\n    }\n  \n    .right {\n      padding: 0;\n      margin: 0;\n      width: 90vw;\n    }\n  \n    .socials{\n      margin: auto;\n      width: 105px !important;\n      margin-top: 15px;\n      left: 0px !important;\n      font-size: 7.5px;\n    }\n    .links {\n      display: flex;\n      justify-content: center;\n    }\n  \n    .links p {\n      /* font-size: 15px;\n      text-align: center;\n      margin: 0; */\n    }\n  \n    .links a {\n      /* display: flex;\n      margin: 15px;\n      margin-left: 30px;\n      text-decoration: none;\n      color: black; */\n      align-items: self-end;\n    }\n  \n    .icon {\n      font-size: 15px;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
